module.exports = __webpack_public_path__ + "fonts/400-normal-cyrillic-ext.af93dfb.woff2";